// eslint-disable-next-line no-unused-vars
import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import uuid from 'react-uuid'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { noPaddingCard, backgroundColorDiv, hideImageMobileClass } from '../../helpers/imageOptions'
import carouselize from '../Utilities/Carouselize/Carouselize'
import { Arrow } from '../icons'

function BlockCardImage({
  imgData,
  columns,
  showcaseCircles,
  gridLeadershipDesign,
  noGridLeadershipDesign,
  isContentBlog
}) {
  const {
    imageMobile,
    hideImageMobile,
    padImage,
    backgroundImage,
    backgroundImageMobile,
    blockCardBox,
    overlay,
    mobileImageLocation,
    isBlog = isContentBlog,
    decorationBlockCard,
    featuredImage,
    __typename,
    sys
  } = imgData

  const swipeContainer = useRef(null)
  const itemContainer = useRef(null)
  const prevButton = useRef(null)
  const nextButton = useRef(null)
  let { images } = imgData

  useEffect(() => {
    if (images && images.length > 1) {
      const options = {
        swipeContainer: swipeContainer.current,
        itemContainer: itemContainer.current,
        prevButton: prevButton.current,
        nextButton: nextButton.current,
        wrapAround: true, // false will stop turning when reaching first or last item
        numberFocusedItems: 1 // how many items to show at once
      }
      carouselize(options)
    }
  }, [])

  const { contentType } = sys
  if (__typename === 'ContentfulTestingBlogPost' || contentType?.sys?.id === 'testingBlogPost') {
    images = featuredImage
  }
  const overlayClass = {
    Wave: 'wave',
    Fade: 'fade'
  }[overlay]

  let overlayComp
  if (overlayClass) {
    overlayComp = <div className={`overlay ${overlayClass}`} />
  }

  let bgImageComp
  let bgImageMobileComp

  if (backgroundImage) {
    if (getImage(backgroundImage.image)) {
      bgImageComp = (
        <GatsbyImage
          className={`background ${
            backgroundImageMobile && backgroundImageMobile !== null ? 'desktop' : ''
          }`}
          image={getImage(backgroundImage.image)}
          alt={backgroundImage.altText}
        />
      )
    } else {
      bgImageComp = (
        <img
          className={`background ${
            backgroundImageMobile && backgroundImageMobile !== null ? 'desktop' : ''
          }`}
          src={backgroundImage.image?.file?.url}
          srcSet={backgroundImage.image?.file?.url}
          alt={backgroundImage.altText}
        />
      )
    }
  }

  if (backgroundImageMobile) {
    // TODO: need a ticket to finish adding .image to these, currently they - any getImage
    // call with just img instead of img.image - are all defaulting to their else blocks
    // and rendering regular img tags
    if (getImage(backgroundImageMobile)) {
      bgImageMobileComp = (
        <GatsbyImage
          className="background mobile"
          image={getImage(backgroundImageMobile)}
          alt={backgroundImageMobile.altText}
        />
      )
    } else {
      bgImageMobileComp = (
        <img
          className="background mobile"
          src={backgroundImageMobile.image?.file?.url}
          srcSet={backgroundImageMobile.image?.file?.url}
          alt={backgroundImageMobile.altText}
        />
      )
    }
  }

  let imageCarousel
  let imageMobileComp
  let imageComp
  const padImageClass = padImage ? 'pad' : ''
  if (images && images.length === 1) {
    images.map(img => {
      if (getImage(img)) {
        return (imageComp = (
          <GatsbyImage
            className={`image ${padImageClass} ${hideImageMobileClass(hideImageMobile)} ${
              imageMobile && imageMobile !== null ? 'desktop' : ''
            }`}
            image={getImage(img)}
            alt={img.altText}
          />
        ))
      }
      return (imageComp = (
        <img
          className={`image ${padImageClass} ${hideImageMobileClass(hideImageMobile)} ${
            imageMobile && imageMobile !== null ? 'desktop' : ''
          }`}
          src={img.image?.file?.url}
          srcSet={img.image?.file?.url}
          alt={img.altText}
        />
      ))
    })
  }

  if (images && !images.length) {
    if (getImage(images)) {
      imageComp = (
        <GatsbyImage
          className={`image ${padImageClass} ${hideImageMobileClass(hideImageMobile)} ${
            imageMobile && imageMobile !== null ? 'desktop' : ''
          }`}
          image={getImage(images)}
          alt={images.altText}
        />
      )
    }
    imageComp = (
      <GatsbyImage
        className={`image ${padImageClass} ${hideImageMobileClass(hideImageMobile)} ${
          imageMobile && imageMobile !== null ? 'desktop' : ''
        }`}
        image={getImage(images)}
        alt={images.altText}
      />
    )
  }
  if (images && images.length > 1) {
    imageCarousel = (
      <div className="swipe-container block-card-carousel" ref={swipeContainer}>
        <div className="item-container" ref={itemContainer}>
          {images.map(img => {
            const { image } = img
            const { description } = image
            const leadershipCarouselImg = getImage(image)
            if (leadershipCarouselImg) {
              // this is only for Leadership carousel
              let nameAndRole
              if (description) {
                const splitArray = description.trim().split(/([[{].+?[\]}])/)

                nameAndRole = (
                  <h4>
                    {splitArray.map((part, index) => {
                      if (part === '{mbr}') return <span className="mobile-break" />
                      if (part === '{dbr}') return <span className="desktop-break" />
                      if (index > 0 && part !== '{dbr}' && part !== '{mbr}')
                        return (
                          <div>
                            <p>{part.toUpperCase()}</p>
                          </div>
                        )
                      return part
                    })}
                  </h4>
                )
              }

              return (
                <div className="box block-card-image" key={uuid()}>
                  <GatsbyImage
                    loading="eager"
                    className={`image ${padImageClass} ${hideImageMobileClass(hideImageMobile)} ${
                      imageMobile && imageMobile !== null ? 'desktop' : ''
                    }`}
                    image={leadershipCarouselImg}
                    alt={img?.altText}
                  />
                  {nameAndRole}
                </div>
              )
            }
            return (
              <div className="box" key={uuid()}>
                <img
                  className={`image ${padImageClass} ${hideImageMobileClass(hideImageMobile)} ${
                    imageMobile && imageMobile !== null ? 'desktop' : ''
                  }`}
                  src={img.image?.file?.url}
                  srcSet={img.image?.file?.url}
                  alt={img.altText}
                />
              </div>
            )
          })}
        </div>
        <button type="button" className="prev-button prev-img" ref={prevButton}>
          <Arrow
            className="carousel-button__icon--prev"
            width={31}
            height={15.5}
            fill="#fff"
            title="previous button"
          />
        </button>
        <button type="button" className="next-button next-img" ref={nextButton}>
          <Arrow
            className="carousel-button__icon"
            width={31}
            height={15.5}
            fill="#fff"
            title="next button"
          />
        </button>
      </div>
    )
  }

  if (imageMobile) {
    if (getImage(imageMobile)) {
      imageMobileComp = (
        <GatsbyImage
          className={`image ${padImageClass} ${hideImageMobileClass(hideImageMobile)} mobile`}
          image={getImage(imageMobile)}
          alt={imageMobile.altText}
        />
      )
    } else {
      imageMobileComp = (
        <img
          className={`image ${padImageClass} ${hideImageMobileClass(hideImageMobile)} mobile`}
          src={imageMobile.image?.file?.url}
          srcSet={imageMobile.image?.file?.url}
          alt={imageMobile.altText}
        />
      )
    }
  }

  let decoration
  if (decorationBlockCard) {
    decoration = getImage(decorationBlockCard.image) ? (
      <GatsbyImage
        className={`image ${padImageClass} ${hideImageMobileClass(hideImageMobile)} ${
          imageMobile && imageMobile !== null ? 'desktop' : ''
        }`}
        image={getImage(decorationBlockCard.image)}
        alt={decorationBlockCard.altText}
      />
    ) : null
  }
  // Set the image div by the column type
  const ImageDivClasses = columnsName => {
    if (columnsName === 'grid-two-columns') {
      return `two-colums__imgs ${noPaddingCard(blockCardBox)}`
    }
    if (columnsName === 'grid-two-columns-left-wider' || isBlog) {
      return 'grid-row-images'
    }

    if (columns !== 'grid-two-columns-left-wider' && showcaseCircles) {
      return `container__imgs ${backgroundColorDiv(showcaseCircles)} showcase-image ${noPaddingCard(
        blockCardBox
      )}`
    }
    if (gridLeadershipDesign || noGridLeadershipDesign) {
      return `container__imgs ${noPaddingCard(blockCardBox)} leadership-img`
    }

    if (mobileImageLocation && mobileImageLocation.includes('Between')) {
      return `container__imgs ${noPaddingCard(blockCardBox)}`
    }

    return `container__imgs ${noPaddingCard(blockCardBox)} `
  }

  return (
    <>
      {decoration}
      <div className={ImageDivClasses(columns)}>
        {bgImageComp}
        {bgImageMobileComp}
        {imageComp}
        {imageCarousel}
        {imageMobileComp}
        {overlayComp}
      </div>
    </>
  )
}
BlockCardImage.defaultProps = {
  gridLeadershipDesign: false,
  noGridLeadershipDesign: false,
  isContentBlog: false
}

BlockCardImage.propTypes = {
  imgData: PropTypes.object.isRequired,
  columns: PropTypes.string.isRequired,
  showcaseCircles: PropTypes.bool.isRequired,
  gridLeadershipDesign: PropTypes.bool,
  noGridLeadershipDesign: PropTypes.bool,
  isContentBlog: PropTypes.bool
}

export default BlockCardImage
